import {
  ChartContainer,
  ChartLabel,
  ChartLabels,
  ChartTooltip,
  DashBoardBody,
  DashBoardCard,
  DashBoardHeader, selectStyle,
} from "../../assets/GlobalStyles";
import {ResponsiveLine} from '@nivo/line'
import React, {useCallback, useEffect, useState} from "react";
import {useAtom,useAtomValue} from "jotai";
import {dataTotalInfo} from "../../components/common/entity";
import {chartDataAtom, commonProperties, platformStatusType, userPlatformStatusType} from "./entity/Chart";
import {
  adverListColumn,
  adverStatusAtom,
  adverStatusDetailAtom,
  adverStatusDetailColumn, lockedRows, summaryReducer,
  userCampaignListColumn,
} from "./entity/Campaign";
import {targetingType, productType, searchConditionAtom} from "./entity/Common";
import {
  retrieveAdverOverview,
  retrieveOverview,
} from "../../services/dash_board/ChartAxios";
import {
  overviewCacheAtom,
  selectedAdverIdsAtom,
  tokenResultAtom
} from "../login/entity/Common";
import {
  retrieveAdvertiserCampaignStatus,
  retrieveAdvertiserStatus, retrieveUserAdvertiserCampaignStatus
} from "../../services/dash_board/ManageCampaignAxios";
import {dateFormat, decimalFormat, moneyToFixedFormat, numberToFixedFormat} from "../../common/StringUtils";
import Select from "react-select";
import {DashBoardCondition} from "../../components/dashBoard/Condition";
import Table from "../../components/table";
import ReactDataGrid from "@inovua/reactdatagrid-enterprise";
import {selNoticeList} from "../../services/notice/NoticeAxios";
import NoticeTable from "../../components/table/NoticeTable";
import {columnNoticeDashboard} from "../customer/entity/NoticeEntity";

/** 공지사항 **/
function NoticeUser (props) {
  const [tokenUserInfo] = useAtom(tokenResultAtom)

  const [totalInfo, setTotalInfo] = useState(dataTotalInfo);
  const [isSearch, setIsSearch] = useState(false);

  const [searchCondition, setSearchCondition] = useState(
      {keyword:'', pageSize: 10, currentPage: 1, publishYn:'ALL'});

  const loadData = ({skip, limit}) => {
    let params = {
      ...searchCondition,
      currentPage: skip/limit + 1,
      pageSize: limit
    }

    if(tokenUserInfo.role === 'NORMAL') {
      return selNoticeList({...params, publishYn: 'Y'}).then(response => {
        const totalCount = response.totalElements;
        setIsSearch(false);
        setTotalInfo({
          totalCount: totalCount,
          currentCount: response?.content.length,
          currentPage: response.pageNumber,
          totalPages: response.totalPages
        });
        return {data: response?.content, count: parseInt(totalCount)};
      })
    }
  }

  const dataSource = useCallback(loadData, [searchCondition.currentPage, isSearch])
  return (
      <DashBoardCard>
        <DashBoardHeader>공지사항</DashBoardHeader>
        <DashBoardBody>
          <NoticeTable
              columns={tokenUserInfo.role !== 'NORMAL' ? columnNoticeDashboard : columnNoticeDashboard.filter(column => column.name !== 'publishYn')}
              totalCount={[totalInfo.currentCount, '공지사항']}
              defaultLimit={searchCondition.pageSize}
              data={dataSource}
              style={{textAlign: 'start'}}
              pagination={false}
              livePagination={false}
          />
        </DashBoardBody>
      </DashBoardCard>
  )
}

/** 플래폼 현황 차트 **/
function ChartComponent() {
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const [chartData, setChartData] = useState(chartDataAtom);
  const searchCondition = useAtomValue(searchConditionAtom)
  const [dataType, setDataType] = useState('')
  const [dataType2, setDataType2] = useState('')
  const [chartDataInfo, setChartDataInfo] = useState([])
  const [chartList, setChartList] = useState([])
  const overviewCache = useAtomValue(overviewCacheAtom)
  const selectedIds = useAtomValue(selectedAdverIdsAtom)

  useEffect(()=>{
    if(tokenUserInfo.role !== '') {
      if(tokenUserInfo.role !== 'NORMAL') {
          let data = overviewCache  ?? [];
          if (selectedIds.size > 0) {
            data = data.filter(item => selectedIds.has(item.userId))
          }
          const computed = data.map(item => {
            const exposureCount = item.exposureCount ?? 0
            const validClickCount = item.validClickCount ?? 0
            const costAmount = item.costAmount ?? 0
            const totalConversionCount = item.totalConversionCount ?? 0
            const totalConversionAmount = item.totalConversionAmount ?? 0
            const sessionConversionAmount = item.sessionConversionAmount ?? 0
            const directConversionAmount = item.directConversionAmount ?? 0
            return {
              ...item,
              clickRate: exposureCount !== 0 ? (validClickCount / exposureCount) * 100 : 0,
              cpc: validClickCount !== 0 ? costAmount / validClickCount : 0,
              costPerConversion: totalConversionCount !== 0 ? costAmount / totalConversionCount : 0,
              avgConversionAmount: totalConversionCount !== 0 ? totalConversionAmount / totalConversionCount : 0,
              sessionRoas: costAmount !== 0 ? (sessionConversionAmount / costAmount) * 100 : 0,
              directRoas: costAmount !== 0 ? (directConversionAmount / costAmount) * 100 : 0,
              totalRoas: costAmount !== 0 ? (totalConversionAmount / costAmount) * 100 : 0,
              ecpm: exposureCount !== 0 ? (costAmount / exposureCount) * 1000 : 0,
              conversionRate: validClickCount !== 0 ? (totalConversionCount / validClickCount) * 100 : 0,
            }
          })
          const filled = fillMissingDailyRows(computed, searchCondition);
          setChartDataInfo(filled)
      } else {
          let data =  overviewCache  ?? [];
          if(data !== null) {
            data?.map((item,key) => {
              Object.assign(data[key],{clickRate: item.validClickCount !== 0 ? (item.validClickCount / item.exposureCount) *100 : 0})
              Object.assign(data[key],{cpc:item.validClickCount !== 0 ? item?.costAmount / item.validClickCount : 0})
              Object.assign(data[key],{costPerConversion: item.totalConversionCount !== 0 ? item?.costAmount / item.totalConversionCount : 0})
              Object.assign(data[key],{avgConversionAmount: item.totalConversionAmount !== 0 ? item.totalConversionAmount / item.totalConversionCount : 0})
              Object.assign(data[key],{totalRoas: item.totalConversionAmount !== 0 ? (item.totalConversionAmount / item.costAmount) *100 : 0})
              Object.assign(data[key],{ecpm: item.exposureCount !== 0 ? (item?.costAmount / item.exposureCount) *1000 : 0})
              Object.assign(data[key],{conversionRate: item.totalConversionCount !== 0 ? (item.totalConversionCount / item.validClickCount) *100 : 0})
              Object.assign(data[key],{allowInventorys: item.allowInventorys})
              return null
            })
            const filled = fillMissingDailyRows(data ?? [], searchCondition)
            setChartDataInfo(filled)
          }
      }
    }
  },[tokenUserInfo.id, tokenUserInfo.role, searchCondition, overviewCache, selectedIds])

  useEffect(() => {
    makeChartData()
  }, [chartData,chartDataInfo]);

  function _toYmd(d) {
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  function _parseToDate(v) {
    if (!v) return null
    // 'YYYY-MM-DD' 또는 Date 모두 대응
    if (v instanceof Date) return v
    return new Date(String(v).slice(0, 10))
  }

  function fillMissingDailyRows(rows, searchCondition) {
    const src = Array.isArray(rows) ? rows : []
    if (src.length === 0) return src

    const key = 'historyDate'
    const from = _parseToDate(searchCondition?.searchStartDate)
    const to = _parseToDate(searchCondition?.searchEndDate)

    let minD = from
    let maxD = to

    if (!minD || !maxD) {
      const dates = src
      .map(r => _parseToDate(r?.[key]))
      .filter(Boolean)
      .sort((a, b) => a - b)

      minD = minD || dates[0]
      maxD = maxD || dates[dates.length - 1]
    }

    if (!minD || !maxD) return src

    // ✅ 합산 대상 필드(원본 + 파생지표 포함 가능)
    const sumFields = [
      'exposureCount',
      'totalExposureCount',
      'validClickCount',
      'totalClickCount',
      'sessionConversionCount',
      'directConversionCount',
      'exposureConversionCount',
      'totalConversionCount',
      'costAmount',
      'sessionConversionAmount',
      'directConversionAmount',
      'exposureConversionAmount',
      'totalConversionAmount',
      // 파생지표를 rows에 이미 넣어놨다면, 여기 합산은 비추천(재계산이 맞음)
      // 'clickRate', 'cpc', ...
    ]

    const byYmd = new Map()

    // ✅ 같은 날짜면 누적 합산
    for (const r of src) {
      const d = _parseToDate(r?.[key])
      if (!d) continue
      const ymd = _toYmd(d)

      const prev = byYmd.get(ymd)
      if (!prev) {
        const base = {
          ...r,
          [key]: ymd,
          allowInventorys: [...(r?.allowInventorys ?? [])],
        };

        for (const f of sumFields) {
          base[f] = Number(base[f] ?? 0);
        }

        byYmd.set(ymd, base);
        continue;
      }

      // 누적
      for (const f of sumFields) {
        prev[f] = Number(prev[f] ?? 0) + Number(r?.[f] ?? 0)
      }
      const mergedAllowInventorys = [
        ...(prev.allowInventorys ?? []),
        ...(r?.allowInventorys ?? []),
      ];

      const seen = new Set();
      prev.allowInventorys = mergedAllowInventorys.filter((item) => {
        const inventoryId = item?.inventoryId;
        if (inventoryId == null) return false;
        if (seen.has(inventoryId)) return false;
        seen.add(inventoryId);
        return true;
      });
    }

    const out = []
    for (let d = new Date(minD); d <= maxD; d.setDate(d.getDate() + 1)) {
      const ymd = _toYmd(d)
      const hit = byYmd.get(ymd)

      if (hit) {
        out.push(hit)
      } else {
        out.push({
          [key]: ymd,
          exposureCount: 0,
          totalExposureCount: 0,
          validClickCount: 0,
          totalClickCount: 0,
          sessionConversionCount: 0,
          directConversionCount: 0,
          exposureConversionCount: 0,
          totalConversionCount: 0,
          costAmount: 0,
          sessionConversionAmount: 0,
          directConversionAmount: 0,
          exposureConversionAmount: 0,
          totalConversionAmount: 0,
        })
      }
    }

    return out
  }

  function calculateSum(property) {
    function calculatePropertySum(property) { // 전체 값은 따로 계산식 함수로 값 정리
      return chartDataInfo.reduce((prev, next) => prev + next[property], 0);
    }

    //[d] 개별 계산값 정리
    const clickCountSum = calculatePropertySum('validClickCount');
    const exposureCountSum = calculatePropertySum('exposureCount');
    const costAmountSum = calculatePropertySum('costAmount');
    const totalConversionCountSum = calculatePropertySum('totalConversionCount');
    const totalConversionAmountSum = calculatePropertySum('totalConversionAmount');
    const sessionConversionAmountSum = calculatePropertySum('sessionConversionAmount');
    const directConversionAmountSum = calculatePropertySum('directConversionAmount');
    //const exposureConversionAmountSum = calculatePropertySum('exposureConversionAmount');

    //[d] 개별 계산값을 포함한 개별 공식 계싼값 switch 문으로 구성
    let calc = 0;
    switch (property) {
      case 'validClickCount':
      case 'exposureCount':
      case 'totalConversionCount':
      case 'userCount':
      case 'totalExposureCount':
      case 'totalClickCount':
      case 'costAmount':
      case 'sessionConversionAmount':
      case 'directConversionAmount':
      case 'exposureConversionAmount':
      case 'totalConversionAmount':
        calc = chartDataInfo.reduce((prev, next) => prev + next[property], 0);
        break;
      case 'clickRate':
        const caseValueA = exposureCountSum;
        calc = caseValueA !== 0 ? (clickCountSum / exposureCountSum) * 100 : 0;
        break;
      case 'cpc':
        const caseValueB = costAmountSum;
        calc = caseValueB !== 0 ? caseValueB / clickCountSum  : 0;
        break;
      case 'conversionRate':
        const caseValueC = clickCountSum;
        calc = caseValueC !== 0 ? (totalConversionCountSum / clickCountSum) * 100 : 0;
        break;
      case 'costPerConversion':
        const caseValueD = totalConversionCountSum;
        calc = caseValueD !== 0 ? costAmountSum / totalConversionCountSum : 0;
        break;
      case 'avgConversionAmount':
        const caseValueE = totalConversionAmountSum;
        calc = caseValueE !== 0 ? totalConversionAmountSum / totalConversionCountSum : 0;
        break;
      case 'sessionRoas':
        const caseValueF = costAmountSum;
        calc = caseValueF !== 0 ? (sessionConversionAmountSum / costAmountSum) * 100 : 0;
        break;
      case 'directRoas':
        const caseValueG = costAmountSum;
        calc = caseValueG !== 0 ? (directConversionAmountSum / costAmountSum) * 100 : 0;
        break;
      // case 'exposureRoas':
      //   const caseValueH = costAmountSum;
      //   calc = caseValueH !== 0 ? (exposureConversionAmountSum / costAmountSum) * 100 : 0;
      //   break;
      case 'totalRoas':
        const caseValueI = costAmountSum;
        calc = caseValueI !== 0 ? (totalConversionAmountSum / costAmountSum) * 100 : 0;
        break;
      case 'ecpm':
        const caseValueJ = exposureCountSum;
        calc = caseValueJ !== 0 ? (costAmountSum / exposureCountSum) * 1000 : 0;
        break;
      case 'allowInventorys':
        let inventoryCount = new Set(
            (chartDataInfo ?? [])
            .flatMap((item) => item?.allowInventorys ?? [])
            .map((d) => d.inventoryId)
            .filter((v) => v != null)
        ).size;
        calc = inventoryCount;
        break;
      default:
        break;
    }

    let value;
    if (['clickRate','conversionRate','sessionRoas','directRoas','totalRoas'].includes(property)) {
      value = numberToFixedFormat(calc)+'%'
    } else if(['validClickCount','exposureCount','totalConversionCount','userCount','totalExposureCount','totalClickCount'].includes(property)) {
      value = decimalFormat(calc)
    } else if(['allowInventorys'].includes(property)) {
      value = decimalFormat(calc)
    } else {
      value = moneyToFixedFormat(calc)+' 원'
    }
    return value
  }

  const handleOnChangeChartStatus = (statusId) => {
    setChartData({
      ...chartData,
      [statusId]: {
        ...chartData[statusId],
        status: !chartData[statusId].status
      }
    })
  }

  //[d] dataType, dataType2 값에 따라 3개 고정값 status 및 서로 선택한 기본 상태는 유지
  const handleChangeDataType = (e) => {
    setChartData((prevChartData) => {
      const newData = {};
      Object.keys(prevChartData).forEach((key) => {
        newData[key] = {
          ...prevChartData[key],
          status:
              key === e.value || (['validClickCount', 'exposureCount', 'totalConversionCount'].includes(key) &&
                  prevChartData[key].status) || (prevChartData[key].status && key === dataType2),
        };
      });
      return newData;
    });
    setDataType(e.value);
  };

  const handleChangeDataType2 = (e) => {
    setChartData((prevChartData) => {
      const newData = {};
      Object.keys(prevChartData).forEach((key) => {
        newData[key] = {
          ...prevChartData[key],
          status:
              key === e.value || (['validClickCount', 'exposureCount', 'totalConversionCount'].includes(key) &&
                  prevChartData[key].status) || (prevChartData[key].status && key === dataType),
        };
      });
      return newData;
    });
    setDataType2(e.value);
  };

  //[d] chartData 객체에 담았던 컬러 값 필요없이 고정 컬러값 5개로 재구성 기획자 요청 색상!!
  const fixedColors = ['#1A73E8', '#D93025', '#1E8E3E', '#F9AB00', '#7325D9'];
  const makeChartData = () => {
    let list = [];
    Object.entries(chartData).map(([id,key], index) => {
      if(chartData[id].status){
        let colorIndex;
        //[d] 3개 고정값 외 셀렉트 박스로 선택하는 값은 id === dataType 매칭으로 고정색상 사용
        if (id === dataType) {
          colorIndex = 3;
        } else if (id === dataType2) {
          colorIndex = 4;
        } else {
          colorIndex = index % fixedColors.length;
        }
        list.push({
          id: id,
          data: chartDataInfo.map(item => {
            const date = new Date(item?.historyDate);
            const formattedDate = dateFormat(date, 'MM/DD');
            const dateColor = dateFormat(date, 'ddd').includes('Sun') && 'red';
            if(id === 'allowInventorys') {
              let inventoryCount = new Set(
                  (item[id] ?? [])
                  .map((d) => d.inventoryId)
                  .filter((v) => v != null)
              ).size;
              return {color: dateColor, tooltipDate: dateFormat(date, 'YYYY.MM.DD'), x: formattedDate, y: isNaN(inventoryCount) ? 0 : inventoryCount}
            } else {
              return {color: dateColor, tooltipDate: dateFormat(date, 'YYYY.MM.DD'), x: formattedDate, y: isNaN(item[id]) ? 0 : item[id]}
            }
          }),
          color: fixedColors[colorIndex],
          order: colorIndex
        })
      }
      return null
    })
    setChartList(list.sort((a,b) => {if(a.order>b.order){return -1}else{return 1}}))
  }


  const yFormatted = (data) => {
    let value;
    if (['clickRate','conversionRate','sessionRoas','directRoas','totalRoas'].includes(data.serieId)) {
      value = numberToFixedFormat(data.data.y)+'%'
    } else if(['validClickCount','exposureCount','totalConversionCount','userCount','totalExposureCount','totalClickCount'].includes(data.serieId)) {
      value = decimalFormat(data.data.y)
    } else if(['allowInventorys'].includes(data.serieId)) {
      value = decimalFormat(data.data.y)
    } else {
      value = moneyToFixedFormat(data.data.y)+'원'
    }
    return value
  }
  //[d] 고정 3개값 별도 컴포넌트로 재구성
  const ChartLabelFixData = ({ label, active, onClick, dataType, color, calculateSum, decimalFormat }) => (
      <ChartLabel
          active={active}
          onClick={onClick}
      >
        <p>{label}</p>
        <span style={{ background: `${active ? color : 'transparent'}`, color: active ? '#fff' : null }}>
          {decimalFormat(calculateSum(dataType))}
        </span>
      </ChartLabel>
  );

  return (
      <ChartContainer>
        <ChartLabels>
          <ChartLabelFixData
              label="노출수"
              active={chartData['exposureCount'].status}
              onClick={() => handleOnChangeChartStatus('exposureCount')}
              dataType="exposureCount"
              color={fixedColors[0]}
              calculateSum={calculateSum}
              decimalFormat={decimalFormat}
          />
          <ChartLabelFixData
              label="비용"
              active={chartData['costAmount'].status}
              onClick={() => handleOnChangeChartStatus('costAmount')}
              dataType="costAmount"
              color={fixedColors[1]}
              calculateSum={calculateSum}
              decimalFormat={decimalFormat}
          />
          <ChartLabelFixData
              label="CPV"
              active={chartData['ecpm'].status}
              onClick={() => handleOnChangeChartStatus('ecpm')}
              dataType="ecpm"
              color={fixedColors[2]}
              calculateSum={calculateSum}
              decimalFormat={decimalFormat}
          />
          <ChartLabelFixData
              label="노출지면 수"
              active={chartData['allowInventorys'].status}
              onClick={() => handleOnChangeChartStatus('allowInventorys')}
              dataType="allowInventorys"
              color={fixedColors[3]}
              calculateSum={calculateSum}
              decimalFormat={decimalFormat}
          />
          {/*<ChartLabel active={chartData[dataType].status}>*/}
          {/*  <Select styles={selectStyle}*/}
          {/*          isSearchable={false}*/}
          {/*          isDisabled={!chartData[dataType].status}*/}
          {/*          components={{IndicatorSeparator: () => null}}*/}
          {/*          options={tokenUserInfo.role !== 'NORMAL' ? platformStatusType : userPlatformStatusType}*/}
          {/*          value={platformStatusType.filter(options => options.value === dataType)}*/}
          {/*          isOptionDisabled={option => option.value === dataType2}*/}
          {/*          onChange={handleChangeDataType}*/}
          {/*  />*/}
          {/*  <span*/}
          {/*      onClick={() => handleOnChangeChartStatus(dataType)}*/}
          {/*      style={{background:`${chartData[dataType].status === true?fixedColors[3]:'transparent'}`,*/}
          {/*              color:chartData[dataType].status === true?'#fff':null}}>{calculateSum(dataType)}*/}
          {/*  </span>*/}
          {/*</ChartLabel>*/}
          {/*<ChartLabel active={chartData[dataType2].status} >*/}
          {/*  <Select styles={selectStyle}*/}
          {/*          isSearchable={false}*/}
          {/*          isDisabled={!chartData[dataType2].status}*/}
          {/*          options={tokenUserInfo.role !== 'NORMAL' ? platformStatusType : userPlatformStatusType}*/}
          {/*          value={platformStatusType.filter(options => options.value === dataType2)}*/}
          {/*          isOptionDisabled={option => option.value === dataType}*/}
          {/*          onChange={handleChangeDataType2}*/}
          {/*  />*/}
          {/*  <span*/}
          {/*      onClick={() => handleOnChangeChartStatus(dataType2)}*/}
          {/*      style={{background:`${chartData[dataType2].status === true?fixedColors[4]:'transparent'}`,*/}
          {/*              color:chartData[dataType2].status === true?'#fff':null}}>{calculateSum(dataType2)}*/}
          {/*  </span>*/}
          {/*</ChartLabel>*/}
        </ChartLabels>
        <div style={{height: 300}}>
          {chartList[0]?.data.length !== 0 &&
            <ResponsiveLine
              {...commonProperties}
              data={chartList}
              colors={(series) => series.color}
              sliceTooltip={(props) => {
                return (
                  <ChartTooltip>
                    <p className={'date'}>{props.slice.points[0]?.data?.tooltipDate}</p>
                    {props.slice.points?.map((data, key) => {
                      return (
                        <p key={key}>
                          <span style={{color: data.serieColor}}>{chartData[data.serieId].label} : </span><span>{yFormatted(data)}</span>
                        </p>
                      )
                    })}
                  </ChartTooltip>
                )
              }}
            />
          }
        </div>
      </ChartContainer>
  )
}

/** 대시보드 **/
function DashBoardIndex() {
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const [totalInfo, setTotalInfo] = useState(dataTotalInfo)
  const [adverStatusData, setAdverStatusData] = useAtom(adverStatusAtom)
  const [adverStatusDetailData, setAdverStatusDetailData] = useAtom(adverStatusDetailAtom)
  const [searchCondition, setSearchCondition] = useAtom(searchConditionAtom)
  const [searchState, setSearchState] = useState(null)
  const [keyword, setKeyword] = useState('')
  const [gridRef, setGridRef] = useState(null);
  const [, setOverviewCache] = useAtom(overviewCacheAtom)
  const [selectedIds, setSelectedIds] = useAtom(selectedAdverIdsAtom)

  useEffect(() => {
    if(tokenUserInfo.role !=='') {
      if(tokenUserInfo.role !== 'NORMAL') {
        //광고주 현황 조회
        retrieveAdvertiserStatus(searchCondition).then(response => {
          if(response !== null) {
            setAdverStatusData(response.filter(a=>a.status === "NORMAL"))
            setTotalInfo({
              totalCount: response.length
            })
          } else {
            setAdverStatusData([])
          }
        })
        retrieveOverview(searchCondition).then(response => {
          setOverviewCache(response ?? [])
        })
      } else {
        if(!tokenUserInfo?.id) return;
        retrieveUserAdvertiserCampaignStatus(tokenUserInfo.id, searchCondition).then(response => {
          if(response !== null) {
            setAdverStatusData(response.filter(a=>a.step === "COMPLETED"))
            setTotalInfo({
              totalCount: response?.length
            })
          } else {
            setAdverStatusData([])
          }
        })
        retrieveAdverOverview(tokenUserInfo.id, searchCondition).then(response => {
          setOverviewCache(response ?? [])
        });
        setSelectedIds(new Set([tokenUserInfo.id]));
      }
    }
    searchCondition.keyword !== '' ? setKeyword(searchCondition.keyword) : setKeyword('')
    setSearchState({
      ...searchCondition
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchCondition,tokenUserInfo])
  /**
   * 검색 버튼
   */
  const handleData = () => {
    setSearchCondition({
      ...searchState,
      keyword: keyword
    })
  }

  const renderContactsGrid = () => {
    return (
      <ReactDataGrid
        handle={null}
        clearNodeCacheOnDataSourceChange={true}
        defaultSortInfo={{ name: 'costAmount', dir: -1 }}
        dataSource={adverStatusDetailData}
        columns={adverStatusDetailColumn}
        enableColumnAutosize={true}
        groups={false}
        emptyText={'캠페인 리스트가 없습니다.'}
        rowHeight={50}
        headerHeight={40}
        showHoverRows={false}
        activeCell={null}
        style={{marginLeft: '50px'}}
      />
    );
  }
  const rowExpandHeight = ({ data }) => {
    if(data?.campaignCount !== 0) {
      if(data.campaignCount > 6) {
        return 50 + (data.campaignCount * 50)
      } else return 300
    } else return 300;
  }
  return (
      <>
        <DashBoardCard>
          <DashBoardCondition role={tokenUserInfo.role} productType={productType} targetingType={targetingType} handleData={handleData} keyword={keyword} setKeyword={setKeyword} searchState={searchState} setSearchState={setSearchState}/>
        </DashBoardCard>
        <DashBoardCard>
          <DashBoardHeader>{tokenUserInfo.role !== 'NORMAL' ? '플랫폼' : '광고'} 현황</DashBoardHeader>
          <DashBoardBody>
            <ChartComponent searchCondition={searchCondition} />
          </DashBoardBody>
        </DashBoardCard>
        <DashBoardCard>
          <DashBoardHeader>{tokenUserInfo.role !== 'NORMAL' ? '광고주' : '캠페인'} 현황</DashBoardHeader>
          <DashBoardBody>
            {tokenUserInfo.role !== 'NORMAL' ?
              <ReactDataGrid
                licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
                handle={null}
                activeCell={null}
                lockedRows={lockedRows}
                summaryReducer={summaryReducer}
                onReady={setGridRef}
                style={{minHeight: 500, height: adverStatusData?.length * 60}}
                headerHeight={40}
                rowExpandHeight={rowExpandHeight}
                rowHeight={40}
                renderDetailsGrid={renderContactsGrid}
                enableColumnAutosize={true}
                emptyText={'데이터가 없습니다.'}
                idProperty={'userId'}
                defaultSortInfo={{ name: 'adverName', dir: 1 }}
                dataSource={adverStatusData}
                detailsGridCacheKey={'campaignId'}
                columns={adverListColumn}
                onRowClick={({data}) => {
                  const uid = data?.userId;
                  if (!uid) return;

                  setSelectedIds(prev => {
                    const next = new Set(prev);
                    if (next.has(uid)) next.delete(uid);
                    else next.add(uid);
                    return next;
                  })
                }}
                rowStyle={({data}) => {
                  if (selectedIds.has(data?.userId)) {
                    return { background: '#eef4ff' };
                  }
                  return null;
                }}
                onDataSourceCacheChange={()=>{gridRef?.current.collapseAllRows()}}
                //onRowExpand={({id})=>retrieveAdvertiserCampaignStatus(id, searchCondition).then(r=> setAdverStatusDetailData(r))}
                onRowExpand={({data})=> {
                  retrieveAdvertiserCampaignStatus(data?.userId, searchCondition).then(response => {
                    response !== null && setAdverStatusDetailData(
                      response?.map(item =>{
                        return {...item,userId:data?.userId, adverInfo: `${data?.adverName}(${data?.username})`}
                      }).filter(a=>a.step === "COMPLETED")
                    )
                  })
                }}
                limit={30}
                multiRowExpand={false}
                showHoverRows={false}
              />
              : <Table columns={userCampaignListColumn}
                       totalCount={[totalInfo.totalCount, '캠페인']}
                       rowHeight={null}
                       defaultSortInfo={{ name: 'username', dir: -1 }}
                       data={adverStatusData}/>
            }
          </DashBoardBody>
        </DashBoardCard>
        {tokenUserInfo.role === 'NORMAL' && <NoticeUser/> }
      </>
  )
}
export default DashBoardIndex
